<div appTheme class="whats-new-container">

    <div id="whats-new-content">

        <div class="mw-body wn-image-container">
            <img src="../../../assets/images/whats-new/whats-new-body.png" alt="What's New Body">
        </div>

        <div class="wn-button-container">
            <div class="wn-button-image-container" id="whatsNewCheckbox"
                 (mouseover)="onMouseEnter('dont-show')"
                 (mouseleave)="onMouseLeave('dont-show')"
                 (click)="onToggleCheckbox()">
                <img [src]="dontShowButtonImage" alt="What's New - Don't Show Again">
            </div>
            <div
                class="wn-button-image-container"
                (mouseover)="onMouseEnter('more-info')"
                (mouseleave)="onMouseLeave('more-info')">
                <a href="https://www.smrt-logic.com/en/whats_new" target="_blank"><img [src]="moreInfoButtonImage" alt="What's New - More Info"></a>
            </div>
        </div>

        <div class="mw-footer wn-image-container" id="moreInfoBtn">
            <img src="../../../assets/images/whats-new/whats-new-footer.png" alt="What's New - Footer">
        </div>

    </div>

</div>
